import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SignOut, Terminal, Gear } from "@phosphor-icons/react";

export default function TopBar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const time = new Date().toLocaleTimeString("en-US", { hour12: false });

  return (
    <header className="border-b border-[#222] bg-[#050505] sticky top-0 z-30">
      <div className="flex items-center justify-between px-6 h-12">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
            <Terminal size={18} weight="bold" className="text-[#00e676]" />
            <span className="font-heading text-sm font-bold tracking-widest">MOMENTUM<span className="text-[#555]">.TERMINAL</span></span>
          </Link>
          <nav className="hidden md:flex items-center gap-1 text-xs font-mono-data">
            <Link to="/" data-testid="nav-dashboard"
              className={`px-3 py-1 ${loc.pathname === "/" ? "bg-white text-black" : "text-[#8a8a8e] hover:text-white"}`}>
              DASHBOARD
            </Link>
            <Link to="/watchlist" data-testid="nav-watchlist"
              className={`px-3 py-1 ${loc.pathname === "/watchlist" ? "bg-white text-black" : "text-[#8a8a8e] hover:text-white"}`}>
              WATCHLIST
            </Link>
            <Link to="/signals" data-testid="nav-signals"
              className={`px-3 py-1 ${loc.pathname === "/signals" ? "bg-white text-black" : "text-[#8a8a8e] hover:text-white"}`}>
              SIGNALS
            </Link>
            <Link to="/backtest" data-testid="nav-backtest"
              className={`px-3 py-1 ${loc.pathname === "/backtest" ? "bg-white text-black" : "text-[#8a8a8e] hover:text-white"}`}>
              BACKTEST
            </Link>
            <Link to="/universe" data-testid="nav-universe"
              className={`px-3 py-1 ${loc.pathname === "/universe" ? "bg-white text-black" : "text-[#8a8a8e] hover:text-white"}`}>
              UNIVERSE
            </Link>
            <Link to="/upgrade" data-testid="nav-upgrade"
              className={`px-3 py-1 ${loc.pathname === "/upgrade" ? "bg-[#f2ce72] text-black" : "text-[#f2ce72] hover:text-white"}`}>
              PRO
            </Link>
          </nav>
        </div>
        <div className="flex items-center gap-4 text-xs font-mono-data text-[#8a8a8e]">
          <span className="hidden sm:inline">{time}</span>
          <span className="hidden md:inline">USER · <span className="text-white">{user?.email}</span></span>
          <Link
            to="/settings"
            data-testid="nav-settings"
            title="Account settings"
            className={`flex items-center gap-1 px-2 py-1 border ${loc.pathname === "/settings" ? "border-white text-white" : "border-[#222] text-[#8a8a8e] hover:text-white hover:border-[#444]"}`}
          >
            <Gear size={14} />
          </Link>
          <button
            data-testid="logout-button"
            onClick={() => { logout(); nav("/login"); }}
            className="flex items-center gap-1 px-2 py-1 border border-[#222] hover:border-[#ff3b30] hover:text-[#ff3b30] transition-colors"
          >
            <SignOut size={14} /> EXIT
          </button>
        </div>
      </div>
    </header>
  );
}
